module.exports = __webpack_public_path__ + "img/icon-morning.f581d144.png";